import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { fetchUnits, selectUnits } from '../features/units/unit.slice';

const useUnits = () => {
    const dispatch = useAppDispatch();
    const units = useAppSelector(selectUnits);

    const getUnits = async () => {
        await dispatch(fetchUnits());
    };

    useEffect(() => {
        if (units.length === 0) {
            getUnits();
        }
    }, []);

    return [units];
};

export default useUnits;
